export const SET_QUIZ_TEMPLATE_FORMDATA = 'SET_QUIZ_TEMPLATE_FORMDATA';
export const SET_BULK_QUIZ_TEMPLATE_FORMDATA = 'SET_BULK_QUIZ_TEMPLATE_FORMDATA';
export const RESET_QUIZ_TEMPLATE_FORMDATA = 'RESET_QUIZ_TEMPLATE_FORMDATA';
